<template lang="pug">
  .profile-page__main
    .profile-page__body
      .manager-quotas-registry
        .manager-quotas-registry__button
          router-link.button.button_paint-main--transparent(
          :to="`/pages/manager/shifts/${$route.params.id}/quotas/create`"
          ) Создать квоту
        .manager-quotas-registry__table
          manager-quotas-registry-scroll-fix-table(
          :tab-head="tabHead"
          :tab-data="tabData"
          @on-delete-quota="onDeleteQuota"
          )
</template>

<script>

import {mapActions} from "vuex";
import ManagerQuotasRegistryScrollFixTable from "./components/ManagerQuotasRegistryScrollFixTable";
export default {
  name: "ManagerQuotasRegistry",
  components: {ManagerQuotasRegistryScrollFixTable},
  props: {
    shiftData: {
      type: Object,
      default: () => ({})

    }
  },
  data() {
    return {
      tabHead: [
        {
          title: "Название"
        },
        {
          title: "Всего мест"
        },
        {
          title: "Осталось"
        }
      ],
      tabData: []
    };
  },
  methods: {
    ...mapActions(["getQuotas", "deleteQuota"]),
    drawTable(shiftData) {
      this.getQuotas({
        campshift: shiftData.id
      }).then(res => {
        this.tabData = res;
        this.$root.$emit("on-hide-preloader");
      });
    },
    onDeleteQuota(quota) {
      this.deleteQuota(quota.id).then(res => {
        if (res.status === 204) {
          const index = this.tabData.findIndex(item => {
            return item.id === quota.id;
          });
          this.tabData.splice(index, 1);
        } else if (res.status === 400) {
          let errorText;
          if (res.data[0].code === 17) {
            errorText = "В данную квоты была подана заявка. Удаление квоты невозможно. Отклоните заявку в квоту и повторите попытку удаления квоты.";
          } else {
            errorText = res.data[0].message;
          }
          this.$root.$emit("onShowErrorModal", {
            text: errorText
          });
        }
      });
    }
  },
  watch: {
    shiftData(val) {
      this.drawTable(val);
    }
  },
  created() {
    this.$root.$emit("on-show-preloader");
  },
  mounted() {
    if (this.shiftData) {
      this.drawTable(this.shiftData);
    }
  }
};
</script>
